import React, { useEffect } from "react";
import HomeReviews from "../components/homepage-components/HomeReviews";
import BoilerSteps from "../components/boiler-page-components/BoilerSteps";
import BoilerExtras from "../components/boiler-page-components/BoilerExtras";
import Faq from "../components/universal-components/Faq";
import BoilerCover from "../components/boiler-page-components/BoilerCover";
import BoilerWarranty from "../components/boiler-page-components/BoilerWarranty";
import Video from "../components/Video";
import BoilerIntro from "../components/boiler-page-components/BoilerIntro";

import BoilerHeroThree from "../components/boiler-page-components/BoilerHeroThree";

const Boilers = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <BoilerHeroThree />
      <BoilerIntro />
      <Video />
      <BoilerExtras />
      <BoilerCover />
      <BoilerWarranty />
      <HomeReviews />
      <Faq />
    </>
  );
};

export default Boilers;
